import React from 'react';

import { Link } from 'react-router-dom';

import Icon from 'components/common/Icons/base/Icon/Icon';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';
import { BreadcrumbsSeparatorIcon } from 'components/common/Icons/common/BreadcrumbsSeparatorIcon/BreadcrumbsSeparatorIcon';

import classes from 'components/Dashboards/Reporting/ReportingBreadCrumbs/ReportingBreadcrumbs.module.scss';
import { BreadcrumbLabel } from 'components/Dashboards/Reporting/ReportingBreadCrumbs/components/BreadcrumbLabel';

interface BreadcrumbItem {
    label?: string;
    to?: string;
    noEllipsis?: boolean;
}

interface Props {
    items: BreadcrumbItem[];
}

export const ReportingBreadcrumbs = ({ items }: Props) => {
    return (
        <nav className={classes.breadcrumbsContainer}>
            {items.map((item, index) => {
                const isLast = index === items.length - 1;

                return (
                    <React.Fragment key={index}>
                        {index > 0 && (
                            <span className={classes.separator}>
                                <BreadcrumbsSeparatorIcon />
                            </span>
                        )}
                        {item.to ? (
                            <Link
                                className={`${classes.breadcrumbItem} ${classes.clickable} ${item.noEllipsis ? classes.noEllipsis : ''}`}
                                to={item.to}
                            >
                                <BreadcrumbLabel
                                    label={item.label ?? ''}
                                    isLastBreadCrumb={isLast}
                                    noEllipsis={item.noEllipsis}
                                />
                            </Link>
                        ) : (
                            <span className={`${classes.breadcrumbItem} ${item.noEllipsis ? classes.noEllipsis : ''}`}>
                                <BreadcrumbLabel
                                    label={item.label ?? ''}
                                    isLastBreadCrumb={isLast}
                                    noEllipsis={item.noEllipsis}
                                />
                            </span>
                        )}
                    </React.Fragment>
                );
            })}
        </nav>
    );
};
